<template>
  <div class="login-index">
    <el-dialog
      top="20vh"
      @open="open"
      @close="close"
      width="752px"
      append-to-body
      :show-close="false"
      custom-class="login-dialog"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="login-wrap">
        <div class="login-header">
          <div class="header-left">
            <span class="login-tips">
              <span class="el-icon-arrow-right" /><span
                class="el-icon-arrow-right"
              /><span class="el-icon-arrow-right" />
              在这里，科研不再是孤岛上的独行
            </span>
          </div>
          <div class="header-right">
            <div class="close-icon-wrap">
              <span
                class="close-icon el-icon-close pointer"
                @click="close"
              ></span>
            </div>
          </div>
        </div>
        <div class="login-main">
          <div class="logo-wrap flex">
            <div class="logo-box">
              <img src="@/assets/img/logo.png" alt="logo" />
            </div>
            <div class="title-slogan">
              <div class="app-title">{{ appSetting.SystemName }}</div>
              <div class="app-slogan">星辰大海，心灵相通</div>
            </div>
          </div>
          <div class="login-way-wrap">
            <ScanLogin v-if="dialogVisible" @afterLogin="afterLogin" />
            <!--  <div class="main-left"></div> -->
            <div class="main-right">
              <div class="login-mode">
                <div
                  :key="mode.value"
                  class="login-mode-item"
                  @click.stop="loginModeChange(mode)"
                  v-for="mode in loginModeList"
                  :class="{ act: loginMode === mode.value }"
                >
                  {{ mode.name }}
                </div>
              </div>
              <el-form
                :model="form"
                :rules="rules"
                ref="form"
                key="form"
                v-if="loginMode === 'sms'"
              >
                <el-form-item prop="user_mobile">
                  <el-input
                    placeholder="中国大陆手机号"
                    v-model="form.user_mobile"
                    prefix-icon="ali-icon-shouji"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="verify_code">
                  <el-input
                    prefix-icon="ali-icon-yanzhengma"
                    placeholder="获取验证码"
                    v-model="form.verify_code"
                  >
                    <el-button
                      slot="suffix"
                      type="text info"
                      @click="fetchVerifyCode($event)"
                      class="security-code pointer"
                      >{{
                        downTimer ? downCount + "s" : "获取验证码"
                      }}</el-button
                    >
                  </el-input>
                </el-form-item>
              </el-form>
              <!-- 密码登录 -->
              <el-form
                key="pwd-form"
                ref="pwd-form"
                :model="pwdForm"
                :rules="pwdRules"
                v-else-if="loginMode == 'pwd'"
              >
                <el-form-item prop="user_mobile">
                  <el-input
                    placeholder="手机号/邮箱"
                    prefix-icon="ali-icon-shouji"
                    v-model="pwdForm.user_mobile"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="user_pwd">
                  <el-input
                    placeholder="密码"
                    prefix-icon="ali-icon-mima1"
                    v-model="pwdForm.user_pwd"
                    :type="showPwd ? 'input' : 'password'"
                  >
                    <el-button
                      slot="suffix"
                      type="text info"
                      class="security-code"
                      @click.stop="showPwd = !showPwd"
                      :class="showPwd ? 'ali-icon-eye-close' : 'ali-icon-eye'"
                    ></el-button>
                  </el-input>
                </el-form-item>
              </el-form>
              <div class="agr-checkbox-wrap">
                <el-checkbox
                  v-model="hasRead"
                  class="custom-checbox"
                  :class="shake ? 'shake' : ''"
                  >登录/注册即代表同意<span
                    class="agr-privacy"
                    @click.stop="navigateTo('user')"
                    >用户协议</span
                  >和<span
                    class="agr-privacy"
                    @click.stop="navigateTo('privacy')"
                    >隐私政策</span
                  ></el-checkbox
                >
              </div>
              <div class="login-btn-wrap">
                <el-button
                  class="login-btn"
                  type="primary"
                  round
                  @click="confirm($event)"
                  ><span v-if="loginMode === 'sms'">登录/注册</span>
                  <span v-else>登录</span>
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="login-footer">
          <span class="tips"
            >首次登录请使用验证码登录，登录后可在账号信息处设置登录密码</span
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex"; //mapState
import ScanLogin from "./components/ScanLogin.vue";
// import { encrypt, decrypt } from "@/utils/crypto.js";
export default {
  name: "login-index",
  components: {
    ScanLogin,
  },
  data() {
    const appSetting = window.appSetting || {};
    const accountValidator = (rule, value, callback) => {
      if (!value) return callback(new Error("请输入手机号/邮箱"));
      const mobileReg = /^1[3-9]\d{9}$/;
      const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/;
      if (!mobileReg.test(value) && !emailReg.test(value))
        return callback(new Error("请输入正确的手机号/邮箱"));
      callback();
    };
    return {
      appSetting,
      dialogVisible: false,
      loginMode: "sms",
      loginModeList: [
        {
          name: "验证码登录",
          value: "sms",
        },
        {
          name: "密码登录",
          value: "pwd",
        },
      ],
      /* 验证码登录 */
      form: { user_mobile: "", verify_code: "" },
      rules: {
        user_mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        verify_code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      /* 密码登录 */
      showPwd: false,
      pwdForm: {
        user_mobile: "",
        user_pwd: "",
      },
      pwdRules: {
        user_mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: accountValidator,
            trigger: "blur",
          },
          // {
          //   pattern: /^1[3-9]\d{9}$/,
          //   message: "请输入正确的手机号码",
          //   trigger: "blur",
          // },
        ],
        user_pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // {
          //   pattern: /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,}$/,
          //   message: "密码必须包含数字和字母,长度至少为8个字符",
          //   trigger: "blur",
          // },
        ],
      },
      hasRead: false,
      shake: false,
      downCount: 60, // 倒计时,
      downTimer: null,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    visibleKey: {
      type: String,
      required: true,
      validator: function (val) {
        return typeof val == "string" && val != "";
      },
    },
  },
  watch: {
    visible: {
      handler: function (val) {
        this.dialogVisible = val;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("user", ["smsLogin", "pwdLogin", "fetchLoginUserInfo"]),
    // 关闭模态框
    close() {
      this.loginModeChange({ value: "sms" }); //  默认初始化为短信登录
      this.$emit("switchModal", this.visibleKey, false);
    },
    loginModeChange(mode) {
      this.loginMode = mode.value;
      this.$nextTick(() => {
        const refName = this.loginMode == "sms" ? "form" : "pwd-form";
        const formRef = this.$refs[refName];
        formRef?.resetFields();
      });
    },
    open() {},
    clearDownTimer() {
      this.downTimer && clearInterval(this.downTimer);
      this.downTimer = null;
      this.downCount = 60;
    },
    setDownTimer() {
      this.downTimer = setInterval(() => {
        this.downCount > 0 ? this.downCount-- : this.clearDownTimer();
      }, 1000);
    },
    /* 获取验证码 */
    fetchVerifyCode(eTarget) {
      try {
        this.$refs["form"]?.validateField("user_mobile", async (valid) => {
          if (valid) return;
          const params = { user_mobile: this.form.user_mobile };
          const resp = await this.$fetch({
            url: "/Sys/getLoginSmsVerifyCode",
            method: "GET",
            params,
            eTarget,
          });
          const { state } = resp || {};
          if (state !== 0) return;
          this.$message.success("发送成功");
          this.setDownTimer(); // 倒计时
        });
      } catch (_) {
        /* eslint-disable-next-line no-empty */
      }
    },
    afterLogin(newUser) {
      this.$emit("afterLogin", newUser);
      !newUser && location.reload(); //  登录成功之后刷新页面 。
    },
    smsLoginTap(eTarget) {
      this.$refs["form"]?.validate(async (valid) => {
        if (!valid) return;
        if (!this.hasRead && (this.shake = true))
          return setTimeout(() => (this.shake = false), 1000);
        const { user_mobile, verify_code } = this.form;
        const params = {
          user_mobile,
          verify_code,
        };
        const resp = await this.smsLogin({ params, eTarget });
        const { flag, data } = resp || {};
        const { is_new_user = false } = data || {};
        const tips = is_new_user ? "注册成功" : "登录成功";
        if (!flag) return;
        this.$message.success(tips);
        this.afterLogin(is_new_user);
      });
    },
    pwdLoginTap(eTarget) {
      this.$refs["pwd-form"]?.validate(async (valid) => {
        if (!valid) return;
        if (!this.hasRead && (this.shake = true))
          return setTimeout(() => (this.shake = false), 1000);
        const { user_mobile, user_pwd } = this.pwdForm;
        const params = {
          user_mobile,
          user_pwd,
        };
        const resp = await this.pwdLogin({ params, eTarget });
        const { flag, data } = resp || {};
        const { is_new_user = false } = data || {};
        if (!flag) return;
        const tips = "登录成功";
        this.$message.success(tips);
        this.afterLogin(is_new_user);
      });
    },
    confirm(eTarget) {
      const funcMap = new Map([
        ["sms", this.smsLoginTap],
        ["pwd", this.pwdLoginTap],
      ]);
      const func = funcMap.get(this.loginMode);
      func && this.$nextTick(() => func(eTarget));
    },
    navigateTo(enu) {
      const pathMap = new Map([
        ["user", "/platform/user"],
        ["privacy", "/platform/privacy"],
      ]);
      const path = pathMap.get(enu);
      path && this.$router.push({ path });
      this.close();
    },
  },
  beforeDestroy() {
    this.clearDownTimer();
  },
};
</script>
<style lang="scss">
@keyframes shake {
  0% {
    transform: translate(0, 0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate(-10px, 0);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translate(10px, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
.shake {
  animation: shake 1s ease-in-out infinite;
  .el-checkbox__label {
    color: #f56c6c !important;
    .agr-privacy {
      color: #f56c6c !important;
    }
  }
}
.login-dialog {
  border-radius: 10px !important;
  .el-dialog__header {
    padding: 0 !important;
    display: none !important;
  }
  .el-dialog__body {
    padding: 0 !important;
    margin: 0 !important;
  }
  .login-wrap {
    width: 752px;
    font-size: 14px;
    border-radius: 10px;
    background: linear-gradient(360deg, #e5eaf6 0%, #ffffff 100%);
    .login-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      padding-bottom: 0px;
      border-bottom: 0.5px solid;
      border-image: linear-gradient(
          90deg,
          rgba(238, 234, 255, 1),
          rgba(148, 125, 254, 0)
        )
        1 1;

      .login-tips {
        font-size: 14px;
        color: var(--color-primary);
      }
      .close-icon-wrap {
        width: 40px;
        height: 40px;
        background-color: #f5f5f5;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        .close-icon {
          font-size: 20px;
        }
      }
    }
    .login-main {
      padding: 16px 40px;
      .logo-wrap {
        margin: 16px 0;
        .logo-box {
          width: 56px;
          height: 56px;
          margin-right: 16px;

          > img {
            width: 100%;
            height: 100%;
          }
        }
        .title-slogan {
          .app-title {
            font-size: 24px;
            color: #303133;
            margin-bottom: 4px;
          }
          .app-slogan {
            font-size: 14px;
            color: #909399;
          }
        }
      }
      .login-way-wrap {
        display: flex;
        padding: 16px;
        padding-bottom: 40px;
        gap: 104px;
        .main-left {
          .qr-box {
            width: 200px;
            height: 200px;
            margin-bottom: 26px;
            position: relative;
            &.hide::after {
              content: "暂未开放";
              position: absolute;
              width: 100%;
              height: 100%;
              line-height: 200px;
              top: 0;
              left: 0;
              font-size: 20px;
              text-align: center;
              color: var(--color-primary);
              background-color: rgba(255, 255, 255, 0.9);
            }
          }
          .login-wechat-tips {
            font-size: 16px;
            color: #303133;
            text-align: center;
          }
        }
        .main-right {
          flex: 1;
          .el-input__prefix {
            left: 12px;
          }
          .el-input__inner {
            border-radius: 100px;
          }
          .custom-checbox {
            .el-checkbox__inner {
              border-radius: 100px;
            }
            .agr-privacy {
              color: #303133;
              padding: 0 0.32em;
              cursor: pointer;
              text-decoration: underline;
            }
            .el-checkbox__label {
              color: #909399;
            }
            &.is-checked {
              .el-checkbox__label {
                color: var(--color-primary);
              }
            }
            .agr-privacy {
              color: #303133;
              padding: 0 0.32em;
              cursor: pointer;
            }
          }
          .login-btn-wrap {
            .login-btn {
              width: 100%;
            }
          }
          .security-code {
            display: inline-block;
            margin-right: 16px;
            color: #4a608e;
          }
        }
      }
    }
    .login-footer {
      text-align: center;
      padding-bottom: 20px;
      .tips {
        font-size: 14px;
        color: var(--color-info-light);
      }
    }
  }
  .login-mode {
    height: 26px;
    margin-bottom: 24px;
    display: flex;
    gap: 20px;
    align-items: flex-end;
    .login-mode-item {
      font-size: 15px;
      cursor: pointer;
      transition: all 0.2s ease-in;
      &.act {
        font-weight: bolder;
        font-size: 20px;
        color: var(--color-primary);
      }
    }
  }
  .agr-checkbox-wrap {
    height: 40px;
    line-height: 40px;
    margin-bottom: 22px;
  }
}
</style>
